import React from 'react';
import styled from 'styled-components';
import askVantageLogo from '../../../../images/ask_vantage_logo.svg';
import { useAv2ThemeMode } from '../../theme/hooks';

const navbarHeight = 60;

interface Props {
  message?: string;
}

const AccessDeniedView: React.FC<Props> = ({
  message = 'You do not have permission to access Ask Vantage. Please contact your administrator.',
}) => {
  const mode = useAv2ThemeMode();
  return (
    <Wrapper data-bs-theme={mode}>
      <Card>
        <Logo src={askVantageLogo} alt="Ask Vantage" />
        <LockIcon />
        <Title>Access Restricted</Title>
        <Message>{message}</Message>
        <AdminNote>Please talk to your admin for access.</AdminNote>
      </Card>
    </Wrapper>
  );
};

export default AccessDeniedView;

const Wrapper = styled.div`
  position: fixed;
  top: ${navbarHeight}px;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.av2.pageBg};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  max-width: 420px;
  padding: 48px 36px;
  border-radius: 16px;
  background: ${({ theme }) => theme.av2.surfaceElevated};
  border: 1px solid ${({ theme }) => theme.av2.border};
`;

const Logo = styled.img`
  height: 28px;
  margin-bottom: 8px;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.av2.textPrimary};
  margin: 0;
`;

const Message = styled.p`
  font-size: 15px;
  color: ${({ theme }) => theme.av2.textMuted};
  line-height: 1.6;
  margin: 0;
`;

const AdminNote = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.av2.primary};
  margin: 0;
`;

const LockIcon: React.FC = () => (
  <LockIconWrap aria-hidden="true">
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M8 11V7a4 4 0 0 1 8 0v4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="12" cy="16" r="1.5" fill="currentColor" />
    </svg>
  </LockIconWrap>
);

const LockIconWrap = styled.span`
  color: ${({ theme }) => theme.av2.primary};
  display: inline-flex;
`;
